import { render, staticRenderFns } from "./autoCompleteSchema.vue?vue&type=template&id=477dc5ec&scoped=true&"
import script from "./autoCompleteSchema.vue?vue&type=script&lang=js&"
export * from "./autoCompleteSchema.vue?vue&type=script&lang=js&"
import style0 from "./autoCompleteSchema.vue?vue&type=style&index=0&id=477dc5ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "477dc5ec",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItemContent } from 'vuetify/lib/components/VList';
installComponents(component, {VAutocomplete,VIcon,VListItemContent})
